export const RENDER_FOR_EMAIL = `RENDER_FOR_EMAIL`

export function renderforEmail(emailOrNot) {
  return {
    type: RENDER_FOR_EMAIL,
    emailOrNot,
  }
}
